import { i18nNsFactory } from '@atlas-frontend/i18n';
import { type FC, useMemo } from 'react';
import { Button, Dropdown } from 'antd';
import { DropdownItem, TextNormal } from '@atlas-frontend/sdk';
import { type UiPath } from '../paths';
import { UiLink } from '../paths/UiLink';
import { QueryParams, UiPathParams } from '../paths/withParams';
import translations from './OpenDirectoryButton.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'open-directory-button',
);
addTranslations(translations);

export interface OpenDirectoryButtonProps {
  options: {
    id: string;
    path: UiPath;
    params?: Partial<UiPathParams> & Partial<QueryParams>;
    label: string;
  }[];
}

export const OpenDirectoryButton: FC<OpenDirectoryButtonProps> = (props) => {
  const { options } = props;
  const { t } = useTranslation();

  const items = useMemo(
    () =>
      options.map(({ id, path, label, params }) => ({
        key: id,
        label: (
          <UiLink
            id={id}
            path={path}
            params={{ ...(params as any), loadSavedState: '' }}
          >
            <DropdownItem>
              <TextNormal>{label}</TextNormal>
            </DropdownItem>
          </UiLink>
        ),
      })),
    [options],
  );

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Button id="open" type="default">
        {t('button.open')}
      </Button>
    </Dropdown>
  );
};
